import { useEffect, useState } from "react";
import HistoryService from "../../services/HistoryService";
import BookCard from "../BookComponents/BookCard";
import BookDetails from "../BookComponents/BookDetail";
import { ROLES } from "../../services/Constants";
import { useLocation } from "react-router-dom";
import Spinner from "../CommonComponents/Spinner";
import ReservationService from "../../services/ReservationService";
import { getCurrentUser } from "../../services/AuthService";
import MessageModal from "../CommonComponents/MessageModal";


function BorrowingHistory({ user: propUser = null, id: propId = null }) {
    const [history, setHistory] = useState({
        borrowed: [],
        reserved: [],
        returned: []
    });
    const [loading, setLoading] = useState(true);
    const [selectedBookId, setSelectedBookId] = useState(null);
    const [currentUser, setCurrentUser] = useState(null);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [cancelMessage, setCancelMessage] = useState("");
    const [cancelSuccess, setCancelSuccess] = useState(false);
    const location = useLocation();
    const userId = propUser || location.state?.userId;
    const role = propId || location.state?.role;

    useEffect(() => {
        const loadData = async () => {
            try {
                // Load current user
                const userData = await getCurrentUser();
                if (userData.authenticated === true) {
                    setCurrentUser(userData);
                }

                // Load history
                let res;
                if (role && (role === ROLES.EMPLOYEE || role === ROLES.ADMIN) && userId) {
                    res = await HistoryService.getHistoryByUserId(userId);
                } else {
                    res = await HistoryService.getUserHistory();
                }
                setHistory(res);
            } catch (err) {
                console.error("Greška pri dohvaćanju povijesti posudbi:", err);
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [role, userId]);

    const handleCancelReservation = async (bookId) => {
        if (!currentUser || !currentUser.id) {
            setCancelMessage("Morate biti prijavljeni za otkazivanje rezervacije.");
            setCancelSuccess(false);
            setShowCancelModal(true);
            return;
        }

        try {
            const result = await ReservationService.cancelReservation(currentUser.id, bookId);
            setCancelMessage(result.message);
            setCancelSuccess(result.success);
            setShowCancelModal(true);

            if (result.success) {
                // Reload history after successful cancellation
                let res;
                if (role && (role === ROLES.EMPLOYEE || role === ROLES.ADMIN) && userId) {
                    res = await HistoryService.getHistoryByUserId(userId);
                } else {
                    res = await HistoryService.getUserHistory();
                }
                setHistory(res);
            }
        } catch (err) {
            console.error("Greška pri otkazivanju rezervacije:", err);
            setCancelMessage("Greška pri otkazivanju rezervacije.");
            setCancelSuccess(false);
            setShowCancelModal(true);
        }
    };

    const handleCloseModal = () => {
        setShowCancelModal(false);
        setCancelMessage("");
    };

    if (loading) {
        return <Spinner />;
    }

    if (selectedBookId) {
        return (
            <BookDetails
                bookId={selectedBookId}
                onBack={() => setSelectedBookId(null)}
            />
        );
    }

    const renderSection = (title, books, isReserved = false) => (
        <div style={{ width: "100%", marginBottom: "24px", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <h2>{title}</h2>
            {books.length === 0 ? (
                <p>Nema knjiga u ovoj kategoriji.</p>
            ) : (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px"
                }}>
                    {books.map((book) => (
                        <BookCard
                            key={book.id}
                            book={book}
                            user={currentUser}
                            onCancelReservation={isReserved ? handleCancelReservation : undefined}
                        />
                    ))}
                </div>
            )}
        </div>
    );

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "32px", alignItems: "center" }}>
            {renderSection("Posuđene knjige", history.borrowed, false)}
            {renderSection("Rezervirane knjige", history.reserved, true)}
            {renderSection("Vraćene knjige", history.returned, false)}

            <MessageModal
                isOpen={showCancelModal}
                onClose={handleCloseModal}
                title="Otkazivanje rezervacije"
                variant={cancelSuccess ? "success" : "error"}
            >
                {cancelMessage}
            </MessageModal>
        </div>
    );
}

export default BorrowingHistory;
